import { MENU_SCAN_CREDIT_COST } from '@pulsify/shared/dto'
import { ScanLine } from 'lucide-react'
import { useState } from 'react'
import {
  CreditCostNote,
  CreditCostTag,
  useCreditCost,
} from '~/features/shared/components/credit-cost'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'
import { MenuFilePicker } from './menu-file-picker'

interface MenuScanPanelProps {
  businessId: string
  initialFiles?: File[]
  onScan: (files: File[]) => void
}

export function MenuScanPanel({ businessId, initialFiles = [], onScan }: MenuScanPanelProps) {
  const [files, setFiles] = useState(initialFiles)
  const { state: cost } = useCreditCost(businessId, MENU_SCAN_CREDIT_COST)

  return (
    <div className="flex flex-col gap-4">
      <MenuFilePicker files={files} onChange={setFiles} />
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <CreditCostNote businessId={businessId} cost={MENU_SCAN_CREDIT_COST} />
        <Button
          type="button"
          disabled={files.length === 0 || cost === 'short'}
          onClick={() => onScan(files)}
        >
          <ScanLine />
          {m.menuScanAction()}
          <CreditCostTag cost={MENU_SCAN_CREDIT_COST} />
        </Button>
      </div>
    </div>
  )
}
